/*
 * JBK · Rakhi 2026 — free silver gift
 * Qualifies when the cart total AFTER discounts is >= Rs 5,000.
 * Adds a Rs 0 line item for the variant the customer picks, keeps it at qty 1,
 * and removes it again if the cart drops below the threshold.
 * The markup() function below MUST stay in step with snippets/rakhi-gift.liquid.
 */
(function () {
  'use strict';

  var THRESHOLD = 500000; // paise, after discounts
  var COIN_ID = 55376086630691;
  var RAKHI_ID = 55376086663459;
  var DEFAULT_ID = COIN_ID;
  var GIFT_IDS = [COIN_ID, RAKHI_ID];
  var NAMES = {};
  NAMES[COIN_ID] = '0.5&nbsp;g Silver Coin';
  NAMES[RAKHI_ID] = 'Silver Rakhi';
  var SWITCH_LABELS = {};
  SWITCH_LABELS[COIN_ID] = 'Switch to Silver Coin';
  SWITCH_LABELS[RAKHI_ID] = 'Switch to Silver Rakhi';

  var ICON_COIN = '<svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="8.4"/><circle cx="12" cy="12" r="4.5"/><path d="M12 3.6v1.9M12 18.5v1.9M3.6 12h1.9M18.5 12h1.9"/></svg>';
  var ICON_DONE = '<svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="8.4"/><path d="M8.4 12.3l2.5 2.5 4.7-5.3"/></svg>';

  var DECLINE_KEY = 'jbk-rakhi-gift-declined';
  var RELOAD_KEY = 'jbk-rakhi-gift-reloads';
  var MAX_RELOADS = 3;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;
  var lastSignature = '';
  var lastState = null;

  /* ---------- small helpers ---------- */

  function store(key, value) {
    try {
      if (value === null) sessionStorage.removeItem(key);
      else sessionStorage.setItem(key, String(value));
    } catch (e) {}
  }

  function read(key) {
    try { return sessionStorage.getItem(key); } catch (e) { return null; }
  }

  function isDeclined() { return read(DECLINE_KEY) === '1'; }

  function isGift(item) { return GIFT_IDS.indexOf(item.variant_id) !== -1; }

  function inr(paise) {
    var rupees = Math.ceil(paise / 100);
    try { return 'Rs.' + new Intl.NumberFormat('en-IN').format(rupees); }
    catch (e) { return 'Rs.' + rupees; }
  }

  function isCartPage() {
    return !!(window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType === 'cart');
  }

  function post(url, payload) {
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) throw new Error(url + ' failed with ' + response.status);
      return response.json();
    });
  }

  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (response) { return response.json(); });
  }

  /* ---------- state ---------- */

  function analyse(cart) {
    var gifts = (cart.items || []).filter(isGift);
    var giftValue = gifts.reduce(function (sum, item) { return sum + item.final_line_price; }, 0);
    var qualifying = (cart.total_price || 0) - giftValue;

    return {
      gifts: gifts,
      qualifying: qualifying,
      qualifies: qualifying >= THRESHOLD,
      remaining: Math.max(0, THRESHOLD - qualifying),
      chosen: gifts.length ? gifts[0].variant_id : 0
    };
  }

  /* ---------- markup ---------- */

  function head(icon, eyebrow, title) {
    return '<div class="rakhi-gift__head">' +
      '<span class="rakhi-gift__icon">' + icon + '</span>' +
      '<div class="rakhi-gift__head-text">' +
      '<p class="rakhi-gift__eyebrow">' + eyebrow + '</p>' +
      '<p class="rakhi-gift__title">' + title + '</p>' +
      '</div></div>';
  }

  function markup(state) {
    var html;

    if (!state.qualifies) {
      var percent = Math.max(0, Math.min(100, Math.round((state.qualifying / THRESHOLD) * 100)));
      html = head(ICON_COIN, 'Rakhi gift', 'Add ' + inr(state.remaining) + ' more to unlock a free silver gift') +
        '<div class="rakhi-gift__track"><span style="width: ' + percent + '%"></span></div>' +
        '<p class="rakhi-gift__note">Spend Rs 5,000 or more and choose a 0.5&nbsp;g silver coin or a silver rakhi, on us.</p>';
      return '<div class="rakhi-gift__inner">' + html + '</div>';
    }

    if (!state.chosen) {
      html = head(ICON_DONE, 'Rakhi gift unlocked', 'Choose your free silver gift') +
        '<div class="rakhi-gift__choices">' +
        '<button type="button" class="rakhi-gift__choice" data-rakhi-pick="' + COIN_ID + '">0.5 g Silver Coin</button>' +
        '<button type="button" class="rakhi-gift__choice" data-rakhi-pick="' + RAKHI_ID + '">Silver Rakhi</button>' +
        '</div>';
      return '<div class="rakhi-gift__inner rakhi-gift__inner--unlocked">' + html + '</div>';
    }

    var other = state.chosen === COIN_ID ? RAKHI_ID : COIN_ID;
    html = head(ICON_DONE, 'Rakhi gift unlocked', 'Added to your order: <strong>' + NAMES[state.chosen] + '</strong>') +
      '<div class="rakhi-gift__choices">' +
      '<button type="button" class="rakhi-gift__choice" data-rakhi-pick="' + other + '">' + SWITCH_LABELS[other] + '</button>' +
      '<button type="button" class="rakhi-gift__decline" data-rakhi-pick="-1">No thanks</button>' +
      '</div>';
    return '<div class="rakhi-gift__inner rakhi-gift__inner--unlocked">' + html + '</div>';
  }

  function render(state) {
    lastState = state;
    var nodes = document.querySelectorAll('rakhi-gift');
    for (var i = 0; i < nodes.length; i++) nodes[i].innerHTML = markup(state);
  }

  /* ---------- mutations ---------- */

  function reconcile(state, desiredId) {
    var operations = [];
    var keep = null;
    var i;

    if (desiredId) {
      for (i = 0; i < state.gifts.length; i++) {
        if (state.gifts[i].variant_id === desiredId && !keep) keep = state.gifts[i];
        else operations.push({ id: state.gifts[i].key, quantity: 0 });
      }
      if (keep && keep.quantity !== 1) operations.push({ id: keep.key, quantity: 1 });
    } else {
      for (i = 0; i < state.gifts.length; i++) operations.push({ id: state.gifts[i].key, quantity: 0 });
    }

    var needsAdd = !!desiredId && !keep;
    if (!operations.length && !needsAdd) return Promise.resolve(false);

    var chain = Promise.resolve();
    operations.forEach(function (operation) {
      chain = chain.then(function () { return post('cart/change.js', operation); });
    });
    if (needsAdd) {
      chain = chain.then(function () {
        return post('cart/add.js', { items: [{ id: desiredId, quantity: 1 }] });
      });
    }
    return chain.then(function () { return true; });
  }

  function refreshDrawer() {
    return fetch(root + '?sections=cart-drawer', { cache: 'no-store' })
      .then(function (response) { return response.json(); })
      .then(function (sections) {
        if (!sections || !sections['cart-drawer']) return;
        var parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var fresh = parsed.getElementById('cart-drawer');
        var current = document.getElementById('cart-drawer');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  function afterMutation() {
    if (isCartPage()) {
      var count = parseInt(read(RELOAD_KEY) || '0', 10) + 1;
      store(RELOAD_KEY, count);
      if (count <= MAX_RELOADS) { window.location.reload(); return Promise.resolve(); }
      return Promise.resolve();
    }

    return refreshDrawer()
      .then(getCart)
      .then(function (cart) {
        lastSignature = '';
        // Repaint from the authoritative post-mutation cart BEFORE telling the rest
        // of the theme, so the chooser can never disagree with the line items.
        // refreshDrawer() re-attaches a fresh rakhi-gift element whose
        // connectedCallback paints the previous state — this overwrites it.
        render(analyse(cart));
        // Deferred so the re-entrancy lock (busy) is already released when the
        // theme's own cart:change listeners — and ours — run.
        setTimeout(function () {
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'rakhi-gift', cart: cart }
          }));
        }, 0);
      });
  }

  /* ---------- controller ---------- */

  function run(cart, options) {
    options = options || {};
    if (busy || !cart) return;

    var state = analyse(cart);
    var pick = options.pick;
    var desired = 0;

    if (pick && pick > 0) desired = pick;
    else if (pick === -1) desired = 0;
    else if (!isDeclined()) desired = state.chosen || DEFAULT_ID;

    // Never hand out the gift below the threshold, however the line got there.
    if (!state.qualifies) desired = 0;

    var signature = [
      state.qualifying,
      state.gifts.map(function (gift) { return gift.variant_id + 'x' + gift.quantity; }).join(','),
      desired
    ].join('|');

    if (!pick && signature === lastSignature) { render(state); return; }
    lastSignature = signature;

    busy = true;
    reconcile(state, desired)
      .then(function (mutated) {
        if (!mutated) { store(RELOAD_KEY, null); render(state); return null; }
        return afterMutation();
      })
      .catch(function (error) {
        if (window.console) console.warn('[rakhi-gift]', error);
        render(state);
      })
      .then(function () { busy = false; });
  }

  /* ---------- wiring ---------- */

  document.addEventListener('cart:change', function (event) {
    if (event.detail && event.detail.cart) run(event.detail.cart);
  });

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var button = target.closest('[data-rakhi-pick]');
    if (!button) return;

    event.preventDefault();
    if (busy) return;

    var pick = parseInt(button.getAttribute('data-rakhi-pick'), 10);
    store(DECLINE_KEY, pick === -1 ? 1 : null);

    var buttons = button.parentNode ? button.parentNode.querySelectorAll('button') : [button];
    for (var i = 0; i < buttons.length; i++) buttons[i].disabled = true;

    getCart().then(function (cart) { run(cart, { pick: pick }); });
  });

  function init() {
    if (!document.querySelector('rakhi-gift')) return;
    getCart().then(function (cart) { run(cart); });
  }

  window.addEventListener('pageshow', function (event) { if (event.persisted) init(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  if (window.customElements && !window.customElements.get('rakhi-gift')) {
    window.customElements.define('rakhi-gift', class extends HTMLElement {
      connectedCallback() { if (lastState) this.innerHTML = markup(lastState); }
    });
  }
})();